import handleGlobalRedirect from "MMT-UI/UpdateGlobalURL";
import { getEntityType } from "./CommonUtils";
import CacheMaster from "../caching/cacheMaster";

export default async function (params) {
  const {
    req,
    res,
    param: query,
    currentDomainName: hostName,
    isIntl,
    localeSettings,
    isBot,
  } = params || {};
  if (localeSettings) {
    let returnValue = false;
    const urlRedirectionFlag = await CacheMaster.getCache("urlRedirectionFlag");
    const customUrl = customRedirectionUrl(
      query,
      hostName,
      isIntl,
      req,
      urlRedirectionFlag === "true",
    );
    if (customUrl) {
      res.writeHead(301, { Location: customUrl });
      res.end();
      return true;
    }
    await handleGlobalRedirect({
      isGlobalEnable: localeSettings?.isGlobalFlagEnabled || false,
      callBackRedirection(url) {
        if (url && localeSettings?.isGlobalFlagEnabled && !isBot) {
          returnValue = true;
          res.writeHead(302, { Location: url });
          res.end();
        }
      },
      req,
      res,
    });
    if (res.statusCode === 302) {
      return true; // Ensure no further code is executed after the redirect
    }
    return returnValue;
  }
}

function customRedirectionUrl(query, hostName, isIntl, req, urlRedirectionFlag) {
  if (urlRedirectionFlag) {
    if (getEntityType(hostName) === "IN" && query && query?.length > 1 && isIntl) {
      // redirect to mmt.global or ae.mmt.global
      if (query[0] === "united_arab_emirates") {
        return `//ae.makemytrip.global${req.url}`;
      } else {
        return `//www.makemytrip.global${req.url}`;
      }
    } else if (getEntityType(hostName) === "AE") {
      if (!isIntl) {
        return `//${hostName}/flights/`;
      }
      if (query && query?.length === 1) {
        return `//${hostName}/flights/`;
      }
      if (query[0] !== "united_arab_emirates") {
        return `//${hostName}/flights/`;
      }
    } else if (getEntityType(hostName) === "GLOBAL") {
      if (!isIntl) {
        return `//${hostName}/flights/`;
      }
      if (query && query?.length === 1) {
        return `//${hostName}/flights/`;
      }
      if (query && query?.length > 1 && query[0] === "united_arab_emirates") {
        //redirect to ae.mmt.global
        return `//ae.makemytrip.global${req.url}`;
      }
    }
  }
  return "";
}
